import { Component, Input } from '@angular/core';
import { models } from 'powerbi-client';

export type PowerBIEventHandler = (event?: { detail?: unknown }, embeddedEntity?: unknown) => void | null;

@Component({
  selector: 'app-powerbi-report',

  templateUrl: './powerbi-report.component.html',
  styleUrl: './powerbi-report.component.scss'
})
export class PowerbiReportComponent {


  @Input() reportConfig: {
    type: 'report',
    id: '',
    embedUrl: '',
    accessToken: '', tokenType: models.TokenType.Embed,
    hostname: "https://app.powerbi.com",
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false }
      }
    }
  };

  /** Optional: event handlers for the embed (e.g. dataHyperlinkClicked, tileClicked) to intercept navigation. */
  @Input() eventHandlers?: Map<string, PowerBIEventHandler> | null;

}
